import React from "react"
import { Link } from "gatsby"

import { Navbar, Nav, Container } from "react-bootstrap"

const CustomNavbar = ({ pageInfo }) => {
  console.log(pageInfo)
  return (
    <>
      <Navbar className="navbar-custom fixed-top" variant="dark" expand="lg" id="site-navbar">
        <Container>
          <a href="https://www.schueleraustausch.net/" className="link-no-style">
            <Navbar.Brand as="span">Schueleraustausch.Net</Navbar.Brand>
          </a>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto" activeKey={pageInfo && pageInfo.pageName}>
              <Link to='/' className='link-no-style'>
                <Nav.Link as="span" eventKey="index">
                  X-CHANGE-Meetup 2021
                </Nav.Link>
              </Link>
              <Link to='/programm/' className='link-no-style'>
                <Nav.Link as="span" eventKey="programm">
                  Programm
                </Nav.Link>
              </Link>
              <Link to='/lineup/' className='link-no-style'>
                <Nav.Link as="span" eventKey="lineup">
                  Lineup
                </Nav.Link>
              </Link>
              <Link to='/register/' className='link-no-style'>
                <Nav.Link as="span" eventKey="register">
                  Anmeldung
                </Nav.Link>
              </Link>
            </Nav>
            <Nav className="ml-auto">
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default CustomNavbar
